<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");
html,
body,
h1,
h2,
h3,
h4,
h5,
h6,
.v-application {
  font-family: "Kanit", sans-serif !important;
}
.v-application .headline {
  font-family: "Kanit", sans-serif !important;
}
.v-application .title {
  font-family: "Kanit", sans-serif !important;
}
</style>
